import axios from 'axios/index';

export default apiUrl =>
  axios({
    method: 'get',
    url: apiUrl,
    responseType: 'json'
  }).then(({ data }) => data);
